import { useContext } from "react";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { LocaleContext } from "../../../routing/LangRouter";

//import constants
import { IS_MOBILE } from "../../../constants/breakpoints";

//import utils
import { formatPersianDate } from "../../../utils/date";

//import general components
import ActionButton from "./action-button";

const FlightContent = ({ flightData, flightClass }) => {
    //general variables
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    const informationList = [
        { id: 1, title: t("departure"), data: flightData?.departure?.city?.persian || flightData?.departureFaName }, //inFlight||flight
        { id: 2, title: t("destination"), data: flightData?.destination?.city?.persian || flightData?.destinationFaName }, //inFlight||flight
        { id: 3, title: t("flightTime"), data: flightData?.departureTime || flightData?.departure_time },
        { id: 4, title: t("flightClass"), data: flightClass },
        { id: 5, title: t("aircraft"), data: flightData?.aircraft },
        { id: 6, title: t("flightNumber"), data: flightData?.flightNumber || flightData?.flight_number },
    ];

    return (
        <Grid container item xs={12} rowGap={2} justifyContent={{ md: "space-between" }}>
            <Grid className="selected-item" container item md="auto" columnGap={1}>
                <img src={flightData?.airline?.image || flightData?.airlineLogo} />
                <Grid container item xs="auto" direction="column">
                    <span className="selected-item__airline-name">{flightData?.airline?.persian || flightData?.airlinePersian}</span>
                    <span className="selected-item__date">
                        {" "}
                        {locale === "en"
                            ? moment(flightData?.departureDate || flightData?.departure_date).format("ddd D MMM")
                            : formatPersianDate(flightData?.departureDate || flightData?.departure_date, {
                                  day: "numeric",
                                  month: "long",
                                  year: undefined,
                                  weekday: "long",
                              })}
                    </span>
                </Grid>
            </Grid>
            {informationList.map(information => {
                return (
                    <Grid container item xs={3} md="auto" direction="column">
                        <span className="selected-item__title-details">{information.title}</span>
                        <span className="selected-item__details">{information?.data}</span>
                    </Grid>
                );
            })}
        </Grid>
    );
};

function SelectedTicket({ type, selectedFlight, handleRemoveTicket }) {
    //general variables
    const { t } = useTranslation();

    //sessionStorage variables
    const domesticFlightInformation = JSON.parse(sessionStorage.getItem("domesticFlightInformation")) || {};
    const { isAutomaticReserve } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const isTwoWay = domesticFlightInformation?.returnDate;

    return (
        <Grid className={`${!IS_MOBILE && "selected-item"} `} container item xs={12} justifyContent="space-between" alignItems="center">
            <Grid container item md={10} rowGap={3}>
                <Grid container item xs={12} rowGap={1}>
                    <Grid component="span" container item md="auto" className="selected-item__title">
                        {t("departureFlight")}
                    </Grid>
                    {type === "intFlight" ? (
                        selectedFlight?.segments?.map(segment => {
                            return <FlightContent flightData={segment} flightClass={selectedFlight?.cabin?.persian} />;
                        })
                    ) : (
                        <FlightContent flightData={selectedFlight?.departure} flightClass={selectedFlight?.departure?.cabinPersian} />
                    )}
                </Grid>

                {(selectedFlight?.return_segments?.length > 0 || !!isTwoWay) && (
                    <Grid container item xs={12} rowGap={2}>
                        <Grid component="span" container item md="auto" className="selected-item__title">
                            {t("returnFlight")}
                        </Grid>
                        {type === "intFlight" ? (
                            selectedFlight?.return_segments?.map(segment => {
                                return <FlightContent flightData={segment} flightClass={selectedFlight?.cabin?.persian} />;
                            })
                        ) : (
                            <FlightContent flightData={selectedFlight?.return} flightClass={selectedFlight?.return?.cabinPersian} />
                        )}
                    </Grid>
                )}
            </Grid>

            {!IS_MOBILE && !isAutomaticReserve && (
                <ActionButton
                    text={t("remove")}
                    price={selectedFlight?.fares?.total_price || selectedFlight?.departure?.totalPrice || 0}
                    handleRemove={handleRemoveTicket}
                />
            )}
        </Grid>
    );
}

export default SelectedTicket;
